import { z } from 'zod'

import { blockOf, mediaIdSchema, mediaSchema } from './common'
import { BlockType } from './types'

export const quoteBlockSchema = z.object({
    ...blockOf(BlockType.QUOTE),
    text: z.string(),
    authorName: z.string(),
    authorRole: z.string(),
    authorPhotoMediaId: mediaIdSchema,
    authorPhotoMedia: mediaSchema,
})

export type QuoteBlockData = z.infer<typeof quoteBlockSchema>
